import { ConfirmNavigationModal } from './ConfirmNavigationModal'

export default ConfirmNavigationModal
